// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BK0zJM {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background-color: rgba(22, 45, 61, 0.66);
}

.BK0zJM *:focus-visible
{
    box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #116dff !important;
    z-index: 999 !important;
}

._4q546 {
    position: absolute;
    left: 50%;
    top: 50%;

    transform: translate(-50%, -50%);
    box-sizing: border-box;
    width: 80%;
    max-width: 600px;
    max-height: 80%;
    padding: 30px 0 0 30px;
    border-radius: 10px;
    box-shadow: -8px -7px 20px 0 rgba(0, 0, 0, 0.1);

    display: flex;
    flex-direction: column;
    background: #fff;
}

.t3uUn2 {
    font-family: Madefor-Text, Madefor;
    font-weight: 500;
    font-size: 32px;
    color: #000;

    margin: 0;
    padding: 0 24px 0 0;
}

.Dd7_m5 {
    position: relative;
    overflow: auto;

    max-height: 390px;
    margin-top: 5px;
    flex-shrink: 1;
}

.BK0zJM .VD6kZX input#queyns {
    box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #116dff !important;
    z-index: 999 !important;
}

.C9M4se {
    position: relative;
    padding: 20px 90px 30px 0;
    margin-right: 30px;

    border-bottom: 1px solid rgba(0,0,0,0.1);
}

.C9M4se:last-child {
    border: none;
}


.QB2oti {
    font-family: Madefor-Text, Madefor;
    font-size: 19px;
    font-weight: 500;
    margin: 0;
    padding: 0;
}

.uFuuCF {
    margin: 12px 0 0 0;
    padding: 0;
    text-align: left;
    font-size: 14px;
    line-height: 21px;
}

.VD6kZX {
    position: absolute;
    right: 0;
    top: 30px;
}

.DvEoR5 {
    padding: 30px;
    border-top: 1px solid rgba(0,0,0,0.1);

    text-align: right;
}

.qSUyqx {
    position: absolute;
    right: 13px;
    top: 13px;
}

:ie11 ._4q546 {
    height: 60%;
}

:ie11 .Dd7_m5 {
    height: 100%;
}

@media (max-height: 320px) {
    ._4q546 {
        display: none;
    }

    .BK0zJM {
        display: none;
    }
}

@media (max-width: 375px) {
    ._4q546 {
        left: 0;
        top: 0;
        transform: none;
        width: auto;
        height: 100%;
        max-height: none;
        padding: 30px 0 0 20px;
        margin: 0 35px 0 0;
        border-radius: 0;
        box-shadow: none;
    }

    .qSUyqx {
        top: 5px;
        right: 5px;
    }

    .t3uUn2 {
        font-size: 19px;
        line-height: 24px;
    }

    .C9M4se {
        padding: 20px 35px 20px 0;
        margin-right: 20px;

        border-bottom: 1px solid rgba(0,0,0,0.1);
    }

    .VD6kZX {
        top: 20px;
    }

    .Dd7_m5 {
        max-height: none;
    }

    .QB2oti {
        font-size: 16px;
        line-height: 22px;
    }

    .uFuuCF {
        margin-top: 6px;
    }

    .DvEoR5 {
        padding: 24px;
        padding-right: 20px;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `BK0zJM`,
	"body": `_4q546`,
	"head": `t3uUn2`,
	"content": `Dd7_m5`,
	"toggle": `VD6kZX`,
	"modal-recommended-checkbox": `queyns`,
	"modalRecommendedCheckbox": `queyns`,
	"section": `C9M4se`,
	"section_title": `QB2oti`,
	"sectionTitle": `QB2oti`,
	"section_text": `uFuuCF`,
	"sectionText": `uFuuCF`,
	"foot": `DvEoR5`,
	"close": `qSUyqx`
};
export default ___CSS_LOADER_EXPORT___;
